import { render, staticRenderFns } from "./AssignCard.vue?vue&type=template&id=46745fb1&scoped=true&"
import script from "./AssignCard.vue?vue&type=script&lang=ts&"
export * from "./AssignCard.vue?vue&type=script&lang=ts&"
import style0 from "./AssignCard.vue?vue&type=style&index=0&id=46745fb1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46745fb1",
  null
  
)

export default component.exports